import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import image from "../../images/David A. Cifrino.png"
import Article5 from '../../components/Article/ArtclePost5'
function ArticlePost5() {
  return (
<>
<Header/>
<div className="flex flex-col items-start gap-8 w-full max-w-[759px] ml-72 pt-20 px-4 md:px-0">
        
        {/* Frame 2147228712 - Return Link */}
        <button 
          onClick={() => window.history.back()}
          className="flex flex-row items-center gap-2 group cursor-pointer bg-transparent border-0 p-0"
        >
          {/* Return to Press & news */}
          <span className=" font-medium text-base md:text-[20px] leading-6 text-[#898989] group-hover:text-[#141414] transition-colors">
            Return to Press & news
          </span>
          
          {/* iconamoon:arrow-right-2-light */}
          <div className="w-6 h-6 flex items-center justify-center">
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              className="transform group-hover:translate-x-1 transition-transform"
            >
              <path 
                d="M9 6L15 12L9 18" 
                stroke="#898989" 
                strokeWidth="1.8" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                className="group-hover:stroke-[#141414] transition-colors"
              />
            </svg>
          </div>
        </button>
        
        {/* Title */}
        <h1 className="w-full font-['SF Pro Display'] font-bold text-2xl md:text-[32px] leading-[1.2] md:leading-[38px] text-[#141414]">
The Future of Corporate Sustainability and Climate Action in the Anti-“Woke” Era    </h1>
        
        {/* Frame 88 - Author Info */}
        <div className="flex flex-row items-center gap-3 w-auto md:w-[215px]">
          
          {/* Avatar with fallback */}
          <div className="relative">
            <img 
              className="w-12 h-12 md:w-16 md:h-16 bg-cover bg-center rounded-full flex-shrink-0 overflow-hidden bg-gray-200"
      src={image}
              alt="Author Avatar"
            >
              {/* Fallback if image doesn't load */}
            
            </img>
          </div>
          
          {/* Frame 87 - Author Details */}
          <div className="flex flex-col items-start gap-2 md:gap-3 w-auto md:w-[139px]">
            
            {/* Author Name */}
            <span className="font-['SF Pro Display'] font-medium text-sm md:text-base leading-[19px] text-black">
      David A. Cifrino
            </span>
            
            {/* Frame 2147228714 - Date & Read Time */}
            <div className="flex flex-row items-center gap-1 flex-wrap">
              
              {/* Date */}
              <span className="font-['SF Pro Display'] font-normal text-xs leading-[14px] text-[#898989]">
                03/25/2025
              </span>
              
              {/* Dot Separator - hidden on very small screens */}
              <div className="hidden sm:block w-1.5 h-1.5 bg-[#898989] rounded-full" />
              
              {/* Read Time */}
              <span className="font-['SF Pro Display'] font-normal text-xs leading-[14px] text-[#898989] whitespace-nowrap">
                5 mins read
              </span>
            </div>
          </div>
        </div>
      </div>
      <Article5/>

<Footer/>
</>
  )
}


export default ArticlePost5